import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    ...theme.typography.body2,
    flexGrow: 1,
    flexShrink: 1,
    alignSelf: 'stretch',
    padding: theme.spacing(0),
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    alignItems: 'center',
    justifyContent: 'flex-start',
    textTransform: 'none',
    overflow: 'hidden',
    margin: theme.spacing(0)
  },
  row: {
    ...theme.typography.caption,
    display: 'flex',
    flexGrow: 0,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineHeight: `${theme.spacing(1)}px`,
    width: theme.spacing(58),
    padding: theme.spacing(0, 0.5, 0, 1)
  },
  roleRowCell: {
    display: 'flex',
    alignItems: 'center',
    flexGrow: 0,
    flexDirection: 'row',
    alignSelf: 'stretch'
  },
  roleRowCellEdit: {
    minWidth: 100,
    flexBasis: 140,
    padding: theme.spacing(0, 0.5, 0, 1),
    paddingBottom: `min(${theme.spacing(1)}px)`
  },
  roleRowCellReadonly: {
    minWidth: 140,
    flexBasis: 140,
    padding: theme.spacing(0, 0.5, 0, 0.5)
  },
  allocationRowCell: {
    display: 'flex',
    alignItems: 'center',
    flexGrow: 1,
    flexDirection: 'row',
    alignSelf: 'stretch',
    minWidth: 100,
    flexBasis: 140,
    padding: theme.spacing(0, 0, 0, 2)
  },
  allocationRowCellReadonly: {
    padding: theme.spacing(0, 0, 0, 1.5)
  },
  user: {
    justifyContent: 'flex-start',
    alignSelf: 'flex-end',
    paddingBottom: `min(${theme.spacing(1)}px)`
  },
  userReadonly: {
    justifyContent: 'flex-start'
  },
  userText: {
    fontWeight: theme.typography.fontWeightBold,
    maxWidth: theme.spacing(25)
  },
  text: {
    ...theme.typography.body2,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    padding: theme.spacing(0)
  },
  roleText: {
    maxWidth: theme.spacing(14)
  },
  roleTextReadonly: {
    whiteSpace: 'normal',
    overflowWrap: 'break-word',
    maxWidth: theme.spacing(24)
  },
  actionPlaceHolder: { width: theme.spacing(8) }
}));

export default useStyles;
